import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';
import validator from 'validator';

import { connect } from 'react-redux';
import { renderTextField, renderSwitch, renderSwitchV2, renderPasswordField, renderTimePicker } from '../../utils/engageComponents'
import { renderTextFieldWithChips } from '../../utils/engageComponents'

//Material components
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Divider from '@material-ui/core/Divider';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper'
import Modal from '@material-ui/core/Modal'
import Checkbox from '@material-ui/core/Checkbox';

import { sweetAlert } from '../../components/Alert/sweetAlert'

//material icons
import LockIcon from '@material-ui/icons/Lock';

//font awsome components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//Actions
import { UpdateCommuny, AddCommunity, SyncCLCommunity } from '../../actions/communityActions';
import { GetAllVersions, GetVersionsByCommunity, PutCommunityVersion } from '../../actions/versionActions';
import { getALLResidentsByCommunityIDPagination, GetCleanResidents } from '../../actions/residentActions';

import {
    ADD_COMMUNITY_SUCCESS,
    UPDATE_COMMUNITY_SUCCESS
} from '../../constants/communityConstants';

//font Awsome Icons
import {
    faLightbulb,
    faSync
} from "@fortawesome/free-solid-svg-icons";
//three party package
import Moment from 'moment';
import { currentScrollingPage } from "../../constants";
import ModalVoiceSettings from "./ModalVoiceSettings";

const pattern = '[0-9]';

const validate = (values) => {
    const errors = {};


    if (!values.communityName) {
        errors.communityName = 'Please enter a Name';
    }

    if (!values.communityZipcode) {
        errors.communityZipcode = 'Please enter a ZipCode';
    }

    //new validations for communityZipCode
    if (values.communityZipcode) {
        if (values.communityZipcode.toString().length !== 5) {
            errors.communityZipcode = 'Zip code must have 5 digits';
        }

        var regex = new RegExp(pattern);
        if (!regex.test(values.communityZipcode)) {
            errors.communityZipcode = "The zip code must have only numbers";
        }
    }

    //WorxHub Validation
    if (values.worxHub) {
        if (values.worxHub.active) {
            //var partnerId = values.worxHub.partnerId? values.worxHub.partnerId : "");

            var worxHub = values.worxHub
            errors.worxHub = {};

            if (!worxHub.partnerId) {
                errors.worxHub.partnerId = 'Please enter a Partner Id';
            }

            if (!values.worxHub.partnerKey) {
                errors.worxHub.partnerKey = 'Please enter a Partner Key';
            }

            if (!values.worxHub.thwInstance) {
                errors.worxHub.thwInstance = 'Please enter a THW Instance';
            }

            if (!values.worxHub.thwSite) {
                errors.worxHub.thwSite = 'Please enter a THW Site';
            }
        }
    }

    if (values.tels && values.tels.active) {
        var tels = values.tels;
        errors.tels = {};

        if (!tels.businessUnitId) {
            errors.tels.businessUnitId = 'Please enter a business unit id';
        }

        if (!tels.refreshToken) {
            errors.tels.refreshToken = 'Please enter a refresh token';
        }
    }

    return errors;
};


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class AddEditCommunity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            currentPage: currentScrollingPage,
            action: props.data && props.data._id ? 'edit' : 'new',
            _id: props.data._id,
            tabValue: 0,
            chipsArray: (props.data && props.data.tags) ? props.data.tags : [],
            textFieldActualText: '',
            switchEntertain: props.data.entertain360 ? props.data.entertain360.active : false,
            switchEnsure: props.data.ensure360 ? props.data.ensure360.active : false,
            switchWorxHub: props.data.worxHub ? props.data.worxHub.active : false,
            switchSpiro: props.data.spiro100 ? props.data.spiro100.active : false,
            switchCoroHealth: props.data.coroHealth ? props.data.coroHealth.active : false,
            showPassword: false,
            isActiveBreakFast: this.findIfMealIsActive(1),
            isActiveLunch: this.findIfMealIsActive(2),
            isActiveDinner: this.findIfMealIsActive(3),
            isVoiceAvailable: props.data.isVoiceAvailable !== undefined ? props.data.isVoiceAvailable : true,
            voiceChanged: false,
            //Meals
            breakfastStart: this.GetInitialDate(props.data, 'breakfastStart'),// new Date(),
            breakfastEnd: this.GetInitialDate(props.data, 'breakfastEnd'),
            lunchStart: this.GetInitialDate(props.data, 'lunchStart'),
            lunchEnd: this.GetInitialDate(props.data, 'lunchEnd'),
            dinnerStart: this.GetInitialDate(props.data, 'dinnerStart'),
            dinnerEnd: this.GetInitialDate(props.data, 'dinnerEnd'),
            //initialData
            initialData: undefined,
            //Version
            openModalSetVersion: false,
            versionSelected: undefined,
            //TELS
            switchTELS: props.data.tels ? props.data.tels.active : false,
            showModalVoiceSettings: false,
            initialExternalId: props.data.externalId ? props.data.externalId : '',
            externalId: props.data.externalId ? props.data.externalId : ''
        };

        this.observer = React.createRef();
        this.lastVersionRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }));

                    if (this.state._id === undefined)
                        this.props.GetAllVersions(true);
                    else
                        this.props.GetVersionsByCommunity(localStorage.getItem('communityId'), this.state.currentPage);
                }
            });
            if (node) this.observer.current.observe(node)
        };

        if (props.data) {

            //GENERAL
            this.props.dispatch(change('CommunityForm', '_id', props.data._id ? props.data._id : ''));
            this.props.dispatch(change('CommunityForm', 'communityName', props.data.communityName ? props.data.communityName : ''));
            this.props.dispatch(change('CommunityForm', 'communityNickName', props.data.communityNickName ? props.data.communityNickName : ''));
            this.props.dispatch(change('CommunityForm', 'communityId', props.data.communityId ? props.data.communityId : ''));
            this.props.dispatch(change('CommunityForm', 'externalId', props.data.externalId ? props.data.externalId : ''));
            this.props.dispatch(change('CommunityForm', 'communityAddress', props.data.communityAddress ? props.data.communityAddress : ''));
            this.props.dispatch(change('CommunityForm', 'communityCity', props.data.communityCity ? props.data.communityCity : ''));
            this.props.dispatch(change('CommunityForm', 'communityState', props.data.communityState ? props.data.communityState : ''));
            this.props.dispatch(change('CommunityForm', 'communityZipcode', props.data.communityZipcode ? props.data.communityZipcode.toString().padStart(5, '0') : ''));
            this.props.dispatch(change('CommunityForm', 'communityMessagingTopic', props.data.communityMessagingTopic ? props.data.communityMessagingTopic : ''));
            this.props.dispatch(change('CommunityForm', 'communityTags', ''));
            this.props.dispatch(change('CommunityForm', 'communityRepairRecipient', props.data.repairRecipient ? props.data.repairRecipient : ''));
            this.props.dispatch(change('CommunityForm', 'communityLogsRecipient', props.data.logsRecipient ? props.data.logsRecipient : ''));
            this.props.dispatch(change('CommunityForm', 'isVoiceAvailable', props.data.isVoiceAvailable !== undefined ? props.data.isVoiceAvailable : true));

            //INTEGRATION
            this.props.dispatch(change('CommunityForm', 'entertain360.name', props.data.entertain360 ? props.data.entertain360.name : ''));
            this.props.dispatch(change('CommunityForm', 'entertain360.active', props.data.entertain360 ? props.data.entertain360.active : false));
            this.props.dispatch(change('CommunityForm', 'ensure360.name', props.data.ensure360 ? props.data.ensure360.name : ''));
            this.props.dispatch(change('CommunityForm', 'ensure360.active', props.data.ensure360 ? props.data.ensure360.active : false));
            this.props.dispatch(change('CommunityForm', 'worxHub.name', props.data.worxHub ? props.data.worxHub.name : ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.partnerId', props.data.worxHub ? props.data.worxHub.partnerId : ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.partnerKey', props.data.worxHub ? props.data.worxHub.partnerKey : ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.thwInstance', props.data.worxHub ? props.data.worxHub.thwInstance : ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.thwSite', props.data.worxHub ? props.data.worxHub.thwSite : ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.active', props.data.worxHub ? props.data.worxHub.active : false));
            this.props.dispatch(change('CommunityForm', 'spiro100.name', props.data.spiro100 ? props.data.spiro100.name : ''));
            this.props.dispatch(change('CommunityForm', 'spiro100.active', props.data.spiro100 ? props.data.spiro100.active : false));
            this.props.dispatch(change('CommunityForm', 'coroHealth.name', props.data.coroHealth ? props.data.coroHealth.name : ''));
            this.props.dispatch(change('CommunityForm', 'coroHealth.password', props.data.coroHealth ? props.data.coroHealth.password : ''));
            this.props.dispatch(change('CommunityForm', 'tels.active', (props.data.tels && props.data.tels.active) ? props.data.tels.active : false));
            this.props.dispatch(change('CommunityForm', 'tels.businessUnitId', (props.data.tels && props.data.tels.businessUnitId) ? props.data.tels.businessUnitId : ''));
            this.props.dispatch(change('CommunityForm', 'tels.refreshToken', (props.data.tels && props.data.tels.refreshToken) ? props.data.tels.refreshToken : ''));

        } else {
            //GENERAL
            this.props.dispatch(change('CommunityForm', '_id', ''));
            this.props.dispatch(change('CommunityForm', 'communityName', ''));
            this.props.dispatch(change('CommunityForm', 'communityNickName', ''));
            this.props.dispatch(change('CommunityForm', 'communityID', ''));
            this.props.dispatch(change('CommunityForm', 'externalId', ''));
            this.props.dispatch(change('CommunityForm', 'communityAddress', ''));
            this.props.dispatch(change('CommunityForm', 'communityCity', ''));
            this.props.dispatch(change('CommunityForm', 'communityState', ''));
            this.props.dispatch(change('CommunityForm', 'communityZipcode', ''));
            this.props.dispatch(change('CommunityForm', 'communityMessagingTopic', ''));
            this.props.dispatch(change('CommunityForm', 'communityMessagingTags', ''));
            this.props.dispatch(change('CommunityForm', 'communityBreakfastStartTime', ''));
            this.props.dispatch(change('CommunityForm', 'communityBreakfastEndTime', ''));
            this.props.dispatch(change('CommunityForm', 'communityLunchStartTime', ''));
            this.props.dispatch(change('CommunityForm', 'communityLunchEndTime', ''));
            this.props.dispatch(change('CommunityForm', 'communityDinnerStartTime', ''));
            this.props.dispatch(change('CommunityForm', 'communityDinnerEndTime', ''));
            this.props.dispatch(change('CommunityForm', 'communityRepairRecipient', ''));
            this.props.dispatch(change('CommunityForm', 'communityLogsRecipient', ''));
            this.props.dispatch(change('CommunityForm', 'isVoiceAvailable', true));

            //INTEGRATION
            this.props.dispatch(change('CommunityForm', 'entertain360.name', ''));
            this.props.dispatch(change('CommunityForm', 'entertain360.active', false));
            this.props.dispatch(change('CommunityForm', 'ensure360.name', ''));
            this.props.dispatch(change('CommunityForm', 'ensure360.active', false));
            this.props.dispatch(change('CommunityForm', 'worxHub.name', ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.partnerId', ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.partnerKey', ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.thwInstance', ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.thwSite', ''));
            this.props.dispatch(change('CommunityForm', 'worxHub.active', false));
            this.props.dispatch(change('CommunityForm', 'spiro100.name', ''));
            this.props.dispatch(change('CommunityForm', 'spiro100.active', false));
            this.props.dispatch(change('CommunityForm', 'coroHealth.name', ''));
            this.props.dispatch(change('CommunityForm', 'coroHealth.password', ''));
            this.props.dispatch(change('CommunityForm', 'coroHealth.active', false));
            this.props.dispatch(change('CommunityForm', 'tels.active', false));
            this.props.dispatch(change('CommunityForm', 'tels.businessUnitId', ''));
            this.props.dispatch(change('CommunityForm', 'tels.refreshToken', ''));

        }
    }

    //This method will run once the componnet is deploy to the browser
    componentDidMount() {

        if (this.state._id === undefined) {
            this.props.GetAllVersions(true);
            document.title = 'Community - Add Community'
        }
        else {
            this.props.GetVersionsByCommunity(localStorage.getItem('communityId'), this.state.currentPage);
            document.title = 'Community - Update Community'
        }
    }

    findIfMealIsActive(idMeal) {
        let isActive = false;

        if (idMeal && this.props.data && this.props.data.mealsTime) {
            const meal = this.props.data.mealsTime.find(item => item.mealType === idMeal);


            if (meal) {
                isActive = meal.active;
            }
        }

        return isActive;
    }

    //This methos is responsable to handle the click in cancel button
    //it does set state prop OPEN to false so in a rerender this component will not be render (it render the list of issues)
    handleCancel = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    //This method handle the click in save button and depending on if state._id is defined it call method update else it call add method
    //and call closeDialog send as a property by Issue.jsx
    onSubmitHandler = (formData) => {

        let mealsTime = []
        let meal = {}

        if (!(this.state.isActiveBreakFast || this.state.isActiveLunch || this.state.isActiveDinner)) {
            sweetAlert('error', 'At least one meal time is mandatory', 'alert_AddEditActivity_Meal_Error');
            this.setState({ tabValue: 0 })
            return;
        }
        if (this.state.breakfastStart && this.state.breakfastEnd) {
            //provisionalDate = new Date(date.toLocaleString("en-US", {timeZone: timeZoneName}));


            meal = {
                mealType: 1,
                active: this.state.isActiveBreakFast,
                mealName: 'Breakfast',
                timeStart: this.GetUTCDate(this.state.breakfastStart ? this.state.breakfastStart : new Date()),
                //new Date(today.getFullYear(), today.getMonth(), today.getDate(),bStartTime.split(':')[0],bStartTime.split(':')[1]),
                timeEnd: this.GetUTCDate(this.state.breakfastEnd ? this.state.breakfastEnd : new Date())
                //new Date(today.getFullYear(), today.getMonth(), today.getDate(),bEndTime.split(':')[0],bEndTime.split(':')[1])
            }
            mealsTime.push(meal);
        };

        if (this.state.lunchStart && this.state.lunchEnd) {
            meal = {
                mealType: 2,
                active: this.state.isActiveLunch,
                mealName: 'Lunch',
                timeStart: this.GetUTCDate(this.state.lunchStart ? this.state.lunchStart : new Date()),
                //new Date(today.getFullYear(), today.getMonth(), today.getDate(),lStartTime.split(':')[0],lStartTime.split(':')[1]),
                timeEnd: this.GetUTCDate(this.state.lunchEnd ? this.state.lunchEnd : new Date())
                //new Date(today.getFullYear(), today.getMonth(), today.getDate(),LEndTime.split(':')[0],LEndTime.split(':')[1])
            }
            mealsTime.push(meal);
        };

        if (this.state.dinnerStart && this.state.dinnerEnd) {
            meal = {
                mealType: 3,
                active: this.state.isActiveDinner,
                mealName: 'Dinner',
                timeStart: this.GetUTCDate(this.state.dinnerStart ? this.state.dinnerStart : new Date()),
                //new Date(today.getFullYear(), today.getMonth(), today.getDate(),dStartTime.split(':')[0],dStartTime.split(':')[1]),
                timeEnd: this.GetUTCDate(this.state.dinnerEnd ? this.state.dinnerEnd : new Date())
                //new Date(today.getFullYear(), today.getMonth(), today.getDate(),dEndTime.split(':')[0],dEndTime.split(':')[1])
            }
            mealsTime.push(meal);
        };

        // formData.mealsTime = mealsTime;
        // formData.tags = this.state.chipsArray;  

        let initialData = { ...this.props.data, ...formData };
        initialData.mealsTime = mealsTime;
        initialData.tags = this.state.chipsArray;


        delete formData.communityBreakfastStartTime
        delete formData.communityBreakfastEndTime
        delete formData.communityLunchStartTime
        delete formData.communityLunchEndTime
        delete formData.communityDinnerStartTime
        delete formData.communityDinnerEndTime
        delete formData.modalNewResidentTags

        //#region  valid Recipient Emails
        let recipientEmails = formData.communityRepairRecipient ? formData.communityRepairRecipient : '';
        recipientEmails = this.checkIfEmail(recipientEmails);
        initialData.repairRecipient = recipientEmails;

        //#endregion valid Recipient Emails


        //#region  valid logs Recipient Emails
        let recipientLogEmails = formData.communityLogsRecipient ? formData.communityLogsRecipient : '';
        recipientLogEmails = this.checkIfEmail(recipientLogEmails);
        initialData.logsRecipient = recipientLogEmails;

        //#endregion valid logs Recipient Emails


        //setting sDateTime
        //Breakfast
        const bsYear = this.state.breakfastStart.getFullYear();
        const bsMonth = ('0' + (this.state.breakfastStart.getMonth() + 1)).slice(-2);
        const bsDate = ('0' + this.state.breakfastStart.getDate()).slice(-2);
        const bsHour = ('0' + this.state.breakfastStart.getHours()).slice(-2);
        const bsMinute = ('0' + this.state.breakfastStart.getMinutes()).slice(-2);
        const bsDateTime = bsYear + '-' + bsMonth + '-' + bsDate + 'T' + bsHour + ':' + bsMinute + ':00.000Z'

        initialData.bsDateTime = bsDateTime;

        const beYear = this.state.breakfastEnd.getFullYear();
        const beMonth = ('0' + (this.state.breakfastEnd.getMonth() + 1)).slice(-2);
        const beDate = ('0' + this.state.breakfastEnd.getDate()).slice(-2);
        const beHour = ('0' + this.state.breakfastEnd.getHours()).slice(-2);
        const beMinute = ('0' + this.state.breakfastEnd.getMinutes()).slice(-2);
        const beDateTime = beYear + '-' + beMonth + '-' + beDate + 'T' + beHour + ':' + beMinute + ':00.000Z'

        initialData.beDateTime = beDateTime;

        //Lunch
        const lsYear = this.state.lunchStart.getFullYear();
        const lsMonth = ('0' + (this.state.lunchStart.getMonth() + 1)).slice(-2);
        const lsDate = ('0' + this.state.lunchStart.getDate()).slice(-2);
        const lsHour = ('0' + this.state.lunchStart.getHours()).slice(-2);
        const lsMinute = ('0' + this.state.lunchStart.getMinutes()).slice(-2);
        const lsDateTime = lsYear + '-' + lsMonth + '-' + lsDate + 'T' + lsHour + ':' + lsMinute + ':00.000Z'

        initialData.lsDateTime = lsDateTime;

        const leYear = this.state.lunchEnd.getFullYear();
        const leMonth = ('0' + (this.state.lunchEnd.getMonth() + 1)).slice(-2);
        const leDate = ('0' + this.state.lunchEnd.getDate()).slice(-2);
        const leHour = ('0' + this.state.lunchEnd.getHours()).slice(-2);
        const leMinute = ('0' + this.state.lunchEnd.getMinutes()).slice(-2);
        const leDateTime = leYear + '-' + leMonth + '-' + leDate + 'T' + leHour + ':' + leMinute + ':00.000Z'

        initialData.leDateTime = leDateTime;

        //Dinner
        const dsYear = this.state.dinnerStart.getFullYear();
        const dsMonth = ('0' + (this.state.dinnerStart.getMonth() + 1)).slice(-2);
        const dsDate = ('0' + this.state.dinnerStart.getDate()).slice(-2);
        const dsHour = ('0' + this.state.dinnerStart.getHours()).slice(-2);
        const dsMinute = ('0' + this.state.dinnerStart.getMinutes()).slice(-2);
        const dsDateTime = dsYear + '-' + dsMonth + '-' + dsDate + 'T' + dsHour + ':' + dsMinute + ':00.000Z'

        initialData.dsDateTime = dsDateTime;

        const deYear = this.state.dinnerEnd.getFullYear();
        const deMonth = ('0' + (this.state.dinnerEnd.getMonth() + 1)).slice(-2);
        const deDate = ('0' + this.state.dinnerEnd.getDate()).slice(-2);
        const deHour = ('0' + this.state.dinnerEnd.getHours()).slice(-2);
        const deMinute = ('0' + this.state.dinnerEnd.getMinutes()).slice(-2);
        const deDateTime = deYear + '-' + deMonth + '-' + deDate + 'T' + deHour + ':' + deMinute + ':00.000Z'

        initialData.deDateTime = deDateTime;


        if (!this.state.externalId)
            initialData.externalId = "";

        if (!this.state._id) {

            this.setState({ initialData: initialData, openModalSetVersion: true })
        }
        else {
            initialData.voiceChanged = this.state.voiceChanged;
            this.props.UpdateCommuny(this.state._id, initialData); //this.state._id);

            if (this.state.voiceChanged)
                this.props.GetCleanResidents();
            setTimeout(() => {
                this.props.getALLResidentsByCommunityIDPagination(this.props.data.communityId, 1);
            }, 600);
        }
    };


    //#region Styles

    //#region Tabs

    tabStyles = {
        backgroundColor: '#1f1f1f',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        color: 'white',
        fontFamily: 'Gotham-Bold',
        fontSize: '16px',
        textTransform: 'none',

    }

    SelectedTabStyle = {
        backgroundColor: '#454446',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        color: 'white',
        fontFamily: 'Gotham-Bold',
        fontSize: '16px',
        textTransform: 'none',

    }

    HiddenTabStyle = {
        display: 'none',
        backgroundColor: '#454446',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        color: 'white'

    }


    titleEngage = {
        color: '#686868',
        fontSize: '20px',
        fontWeight: 'bold',
        textAlign: 'left'
    }

    dividerStyle = {
        height: '3px'
    }

    inputHidden = {
        display: 'none'
        // displayComponent: 'none'
    }
    //#endregion

    //#region  Styles
    objStyles = {
        GridColum: {
            borderRadius: '9px',
            backgroundColor: '#1f1f1f',
            paddingTop: '2.5rem',
            paddingBottom: '2.5rem',
            paddingLeft: '.5rem',
            paddingRight: '.5rem',
            minHeight: '35px'
        },
        titleEngage: {
            color: '#686868',
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'left'
        }
    }
    //#endregion

    handleTabChange = (event, newValue) => {
        this.handleChangeIndex(newValue);
    };

    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };

    handleChangeIndex = (index) => {
        this.setState({ tabValue: index })
    };
    //end Tabs

    // ChipsTextField
    // Se encarga de el delete de un chip
    handlerOnChipDelete = (chipText) => {
        let newChipArray = this.state.chipsArray;
        const index = newChipArray.indexOf(chipText);

        if (index !== -1) {
            newChipArray.splice(index, 1);
            this.setState({ chipsArray: newChipArray })
        }

    };

    handleOnchangeTextField = (newText) => {
        this.setState({ textFieldActualText: newText });
    };

    handleEntertainClick = () => {
        this.setState({ switchEntertain: !this.state.switchEntertain });
        this.props.dispatch(change('CommunityForm', 'entertain360.active', !this.state.switchEntertain));
    }

    handleVoiceClick = () => {
        this.setState({ showModalVoiceSettings: true });
    }

    //#region Voice Settings Modal

    OnCancelHandler = () => {
        this.setState({ showModalVoiceSettings: false });
    };

    OnEnableVoice = () => {
        this.setState({ isVoiceAvailable: true, voiceChanged: true });
        this.props.dispatch(change('CommunityForm', 'isVoiceAvailable', true));
        this.setState({ showModalVoiceSettings: false });
    }

    OnDisableVoice = () => {
        this.setState({ isVoiceAvailable: false, voiceChanged: true });
        this.props.dispatch(change('CommunityForm', 'isVoiceAvailable', false));
        this.setState({ showModalVoiceSettings: false });
    }
    //#endregion

    handleEnsureClick = () => {
        this.setState({ switchEnsure: !this.state.switchEnsure });
        this.props.dispatch(change('CommunityForm', 'ensure360.active', !this.state.switchEnsure));
    }

    handleWorxHubClick = () => {
        this.setState({ switchWorxHub: !this.state.switchWorxHub });
        this.props.dispatch(change('CommunityForm', 'worxHub.active', !this.state.switchWorxHub));
    }

    handleSpiroClick = () => {
        this.setState({ switchSpiro: !this.state.switchSpiro });
        this.props.dispatch(change('CommunityForm', 'spiro100.active', !this.state.switchSpiro));
    }

    handleCoroHealthClick = () => {
        this.setState({ switchCoroHealth: !this.state.switchCoroHealth });
        this.props.dispatch(change('CommunityForm', 'coroHealth.active', !this.state.switchCoroHealth));
    }

    handleTELSClick = () => {
        this.setState({ switchTELS: !this.state.switchTELS });
        this.props.dispatch(change('CommunityForm', 'tels.active', !this.state.switchTELS));
    }

    handleOnClickAddButton = () => {
        const textNewChip = this.state.textFieldActualText;
        const index = this.state.chipsArray.indexOf(textNewChip);
        let chips = this.state.chipsArray;

        if (chips.length < 10) {
            if (textNewChip.length <= 25) {
                if (index === -1 && textNewChip.length > 0) {
                    chips.push(textNewChip)
                    this.setState({ chipsArray: chips })
                }
            } else {
                const message = 'The tag should contain less than 25 characters';
                sweetAlert('error', message, 'alert_AddEditActivity_Chip_Error');
            }
        } else {
            const message = 'Can´t add more than 10 tags per community';
            sweetAlert('error', message, 'alert_AddEditActivity_MaxChips_Error');
        }
        this.props.dispatch(change('CommunityForm', 'communityTags', ''));
    };
    //end ChipsTextField
    handleShowPassword = () => {
        this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
    };

    //#region  MealsRegion
    handlerOnChangeMealTime(meal, time) {
        this.props.dispatch(change('CommunityForm', meal, time));
    };

    //#endregion

    //#region methods
    Capitalize = (s) => {
        if (typeof s !== 'string') {
            return ''
        } else {


            let newString = s; //.toLocaleLowerCase();
            let namesArray = newString.split(' ');

            const capitalizedNamesArray = namesArray.map(
                (name) => {
                    return name.charAt(0).toUpperCase() + name.slice(1)
                }
            );
            return capitalizedNamesArray.join(' ');
        }
    };

    CheckForValidCaracters = (input, validationType) => {
        let pattern = '^[a-zA-Z0-9\\s_&ñÑáÁàÀäÄâÂçÇéÉëËèÈêÊíÍïÏìÌîÎóÓöÖòÒôÔúÚüÜùÙûÛÿ.\'-]*$';

        if (input.length > 0) {
            var regex = new RegExp(pattern);
            if (regex.test(input)) {
                return input;
            } else {
                return input.substring(0, input.length - 1);
            }
        } else {
            return input;
        }

    };

    isOnError = (field) => {

        switch (field.toLocaleLowerCase()) {
            case 'firstname':
                this.setState({ onErrorModalFirstName: (this.state.modalFirstName === '') });
                break;
            case 'lastname':
                this.setState({ onErrorModalLastName: (this.state.modalLastName === '') });
                break;
            case 'selectedresidentfirstname':
                this.setState({ onErrorSelectedResidentFirstName: (this.state.selectedResidentFirstName === '') });
                setTimeout(() => {
                    this.props.handlerOnErrorFirstName(this.state.onErrorSelectedResidentFirstName)
                }, 150);
                break;
            case 'selectedresidentlastname':
                this.setState({ onErrorSelectedResidentLastName: (this.state.selectedResidentLastName === '') });
                setTimeout(() => {
                    this.props.handlerOnErrorLastName(this.state.onErrorSelectedResidentLastName)
                }, 150);
                break;
            default: break;

        }
    };

    GetUTCDate = (date) => {
        let isoDate = new Date();

        if (this.props.data && this.props.data.timeZoneName) {

        }
        isoDate = new Date(date).toISOString();
        return isoDate;
    };

    GetLocalTimeFromUTC = (isoDate) => {
        const localTime = new Date(isoDate);

        return localTime;
    };


    GetValidTime = (date, fieldName) => {
        const d = new Date(date).toString().toLowerCase();
        let provisionalDate = new Date();

        //If the date is invalid then returns the latest date in the field
        if (d === 'invalid date') {

            switch (fieldName) {
                case 'breakfastStart':
                    //this.setState({breakfastStart: date});
                    provisionalDate = this.state.breakfastStart;
                    break;
                case 'breakfastEnd':
                    //this.setState({breakfastEnd: date});
                    provisionalDate = this.state.breakfastEnd;
                    break;
                case 'lunchStart':
                    //this.setState({lunchStart: date});
                    provisionalDate = this.state.lunchStart;
                    break;
                case 'lunchEnd':
                    //this.setState({lunchEnd: date});
                    provisionalDate = this.state.lunchEnd;
                    break;
                case 'dinnerStart':
                    //this.setState({dinnerStart: date});
                    provisionalDate = this.state.dinnerStart;
                    break;
                case 'dinnerEnd':
                    //this.setState({dinnerEnd: date});
                    provisionalDate = this.state.dinnerEnd;

                    break;
                default:
                    break;
            }
        } else {
            provisionalDate = provisionalDate.setHours(date.getHours(), date.getMinutes(), 0, 0);
        }

        //Get Valid end Time 
        switch (fieldName) {
            case 'breakfastEnd':
                provisionalDate = this.GetValidEndDate(this.state.breakfastStart ? this.state.breakfastStart : new Date(), provisionalDate);
                break;
            case 'lunchEnd':
                provisionalDate = this.GetValidEndDate(this.state.lunchStart ? this.state.lunchStart : new Date(), provisionalDate);
                break;
            case 'dinnerEnd':
                provisionalDate = this.GetValidEndDate(this.state.dinnerStart ? this.state.dinnerStart : new Date(), provisionalDate);
                break;
            default:
                break;
        }

        return new Date(provisionalDate);
    };

    GetInitialDate(initData, mealTime) {
        let provisionalDate = new Date();

        const objBreakfast = (initData.mealsTime) ? initData.mealsTime.find((item) => item.mealType === 1) : undefined;
        const objLunch = (initData.mealsTime) ? initData.mealsTime.find((item) => item.mealType === 2) : undefined;
        const objDinner = (initData.mealsTime) ? initData.mealsTime.find((item) => item.mealType === 3) : undefined;

        switch (mealTime) {
            case 'breakfastStart':
                //provisionalDate = objBreakfast?  new Date(objBreakfast.timeStart): new Date();
                provisionalDate = objBreakfast ? new Date(provisionalDate.setHours(new Date(objBreakfast.timeStart).getHours(), new Date(objBreakfast.timeStart).getMinutes(), 0, 0)) : new Date();
                break;
            case 'breakfastEnd':
                //provisionalDate = objBreakfast? new Date(objBreakfast.timeEnd): new Date() ;
                provisionalDate = objBreakfast ? new Date(provisionalDate.setHours(new Date(objBreakfast.timeEnd).getHours(), new Date(objBreakfast.timeEnd).getMinutes(), 0, 0)) : new Date();
                break;
            case 'lunchStart':
                //provisionalDate = objLunch? new Date (objLunch.timeStart): new Date();
                provisionalDate = objBreakfast ? new Date(provisionalDate.setHours(new Date(objLunch.timeStart).getHours(), new Date(objLunch.timeStart).getMinutes(), 0, 0)) : new Date();
                break;
            case 'lunchEnd':
                //provisionalDate = objLunch? new Date (objLunch.timeEnd): new Date();
                provisionalDate = objBreakfast ? new Date(provisionalDate.setHours(new Date(objLunch.timeEnd).getHours(), new Date(objLunch.timeEnd).getMinutes(), 0, 0)) : new Date();
                break;
            case 'dinnerStart':
                //provisionalDate = objDinner? new Date (objDinner.timeStart): new Date();
                provisionalDate = objBreakfast ? new Date(provisionalDate.setHours(new Date(objDinner.timeStart).getHours(), new Date(objDinner.timeStart).getMinutes(), 0, 0)) : new Date();
                break;
            case 'dinnerEnd':
                //provisionalDate = objDinner? new Date (objDinner.timeEnd): new Date();
                provisionalDate = objBreakfast ? new Date(provisionalDate.setHours(new Date(objDinner.timeEnd).getHours(), new Date(objDinner.timeEnd).getMinutes(), 0, 0)) : new Date();
                break;
            default:
                provisionalDate = new Date();
                break;
        }

        if (initData && initData.timeZoneName) {

            provisionalDate = this.changeTimezoneInDate(provisionalDate, initData.timeZoneName);
            //provisionalDate = new Date(provisionalDate.toLocaleString("en-US", {timeZone: initData.timeZoneName}));


        }
        return provisionalDate;

    };


    changeTimezoneInDate(date, timeZoneName) {
        let provisionalDate = new Date();

        if (date) {
            provisionalDate = new Date(date.toLocaleString("en-US", { timeZone: timeZoneName }));

        }

        return provisionalDate;

    }

    checkIfEmail(stringsEmails) {
        let validEmails = '';
        const emailsArray = stringsEmails.split(';');

        validEmails = emailsArray.filter(item => validator.isEmail(item.trim())).join(';');
        return validEmails;
    };
    //#endregion


    //This method check if startDate is greater than start date and it is, it returns start date and show an alert
    // for the user to know the error 
    GetValidEndDate(startDate, endDate) {
        if (startDate > endDate) {
            const message = 'The start time of the meal cannot be greater than the end time'
            sweetAlert('error', message, 'alert_AddEditActivity_StartTime_Error');
            return startDate;
        } else {
            return endDate;
        }
    }


    ToggleMealSwitch(meal) {

        switch (meal) {
            case 'breakfast':
                this.setState((prevState) => ({ isActiveBreakFast: !prevState.isActiveBreakFast }));
                break;
            case 'lunch':
                this.setState((prevState) => ({ isActiveLunch: !prevState.isActiveLunch }));
                break;
            case 'diner':
                this.setState((prevState) => ({ isActiveDinner: !prevState.isActiveDinner }));
                break;
            default:
                break;
        }
    }


    GetAdornment(options) {
        const type = options.type ? options.type.toLowerCase() : 'info';
        const position = options.position ? options.position.toLowerCase() : 'end';
        const color = options.color ? options.color.toLowerCase() : '#009edd';
        const message = options.message ? options.message : undefined;

        let adornment = undefined;
        switch (type) {
            case 'info':
                adornment =
                    <Tooltip class='GeneralAdornment hoverAdornment' title={message} >
                        <InputAdornment position={position}>
                            <FontAwesomeIcon
                                icon={faLightbulb}
                                style={{ color: color, fontSize: '12px' }}
                            />
                        </InputAdornment>
                    </Tooltip>
                break;
            case 'lock':
                adornment =
                    <InputAdornment class='GeneralAdornment' position={position}>
                        <LockIcon style={{ fontSize: 'medium' }}></LockIcon>
                    </InputAdornment>

                break;
            case 'sync':
                adornment =
                    <Tooltip class='GeneralAdornment hoverAdornment' title={message} >
                        <InputAdornment position={position}>
                            <FontAwesomeIcon
                                icon={faSync}
                                style={{ color: color, fontSize: '12px' }}
                            />
                        </InputAdornment>
                    </Tooltip>
                break;
            default:
                break;
        }


        return adornment


    }

    PrepareCommunityToAdd = () => {

        try {
            const initialData = Object.assign({}, this.state.initialData ? this.state.initialData : undefined);
            const versionSelected = this.state.versionSelected ? this.state.versionSelected : undefined;

            if (initialData && versionSelected) {
                initialData.versionSelected = versionSelected;

                this.props.AddCommunity(initialData);
                this.props.closeDialog(0);
            }

        } catch (err) {
            return undefined
        }
    }

    //#region  INNER COMPONENTS
    VersionListModalComponent = ({ versionList = [] }) => {
        try {
            const styles = {
                paperModal: {
                    backgroundColor: '#1F1F1F',
                    padding: '6px',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50%)',
                    width: '45%',
                    height: '75%',

                },
                titleContainer: {
                    height: '20%',
                    fontSize: '28px',
                    color: 'white',
                    paddingLeft: '10px',
                    border: '1px solid yellow'
                },
                versionListContainer: {
                    height: '70%',
                    overflow: 'auto',
                },
                buttonsContainer: {
                    height: '10%',
                },
                button: {
                    fontSize: '16px',
                    borderRadius: '56px',
                    width: '100%',
                    backgroundColor: '#009cdb',
                    color: 'white',
                    textTransform: 'none',
                }
            }

            return (
                <Modal
                    open={this.state.openModalSetVersion}
                    onClose={() => this.setState({ openModalSetVersion: undefined, versionSelected: undefined })}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <Paper className='modalPaperStyles' elevation={3} style={{ ...styles.paperModal }} color='secondary'>
                        <Grid container justifyContent='center' style={{ height: '100%', fontSize: '12px' }}>
                            <Grid item container justifyContent='center' style={{ height: '100%' }}>
                                <Grid item container alignContent='center' justifyContent='flex-start' xs={12} className='TitleRepairsModal'>
                                    <Grid item >
                                        Versions Available
                                    </Grid>
                                </Grid>
                                <Grid item container xs={12} style={{ ...styles.versionListContainer }} >
                                    {
                                        this.GetVersionListComponent(versionList)
                                    }
                                </Grid>
                                <Grid item container xs={12} alignContent='center' justifyContent='space-around' style={{ ...styles.buttonsContainer }}>
                                    <Grid item xs={3}>
                                        <Button style={{ ...styles.button, backgroundColor: '#959494' }} onClick={() => this.setState({ openModalSetVersion: undefined, versionSelected: undefined })}>Cancel</Button>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Button style={this.state.versionSelected ? { ...styles.button } : { ...styles.button, backgroundColor: '#ffffff', color: '#bdbdbd', }} onClick={() => (this.PrepareCommunityToAdd())} disabled={this.state.versionSelected ? false : true}>Set</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Modal>
            )
        } catch (err) {
            return (
                undefined
            )
        }
    }

    GetVersionListComponent = (versionList = undefined) => {
        try {
            const styles = {
                versionList: {

                }
            }
            return (
                <Grid item container xs={12} alignContent='flex-start' style={{ ...styles.versionList }}>
                    {
                        versionList && versionList.length > 0 ?
                            versionList.map((version) => <this.GetVersionComponent key={`versionComponent_${version._id}`} version={version} />)
                            :
                            <Grid item container className="subtitleRepairsModal">No approved versions found.</Grid>

                    }
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    }

    GetVersionComponent = ({ version = undefined }) => {
        try {

            const border = this.state.versionSelected && this.state.versionSelected === version._id ? '2px solid #009edd' : '2px solid #454446';

            const styles = {
                rowContainer: {
                    padding: '5px 15px',
                },
                versionContainer: {
                    fontSize: '15px',
                    color: 'white',
                    height: '70px',
                    border: border,
                    padding: '5px 10px'
                }
            }

            return (
                <Grid item container xs={12} style={{ ...styles.rowContainer }}>
                    <Grid item container xs={12} className='repairAction' style={{ ...styles.versionContainer }} onClick={() => this.setState({ versionSelected: version._id })} >
                        <Grid item container xs={12} style={{ fontSize: '20px' }}>
                            {`Version: ${version.version.latestVersion}`}
                        </Grid>
                        <Grid item container xs={12}>
                            {version.description}
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container ></Grid>)
        }
    }

    //#endregion

    //#region  INNER COMPONENTS
    VersionRowComponent = ({ versionObj, index }) => {
        const versionData = this.props && this.props.versions && Array.isArray(this.props.versions) ? this.props.versions : []

        try {

            //#region Styles
            const styles = {
                rowStyles: {
                    minHeight: '5rem',
                    backgroundColor: '#1f1f1f',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '5px 10px'
                },
                rowContainerStyles: {
                    margin: '10px 0px',
                },
            }
            //#endregion

            return (
                <Grid item container xs={12} style={{ ...styles.rowContainerStyles }} id={`Version_row_${versionObj._id}`} ref={versionData.length === index + 1 ? this.lastVersionRef : undefined}>
                    <Grid item container xs={12} style={{ ...styles.rowStyles }}>
                        <Grid item container xs={12} md={6} lg={8} style={{ ...styles.columnStyles }}>
                            <this.VersionComponent versionObj={versionObj} />
                        </Grid>
                        <Grid item container xs={12} md={4} lg={3} style={{ ...styles.columnStyles }}>
                            <this.ReleaseDateComponent versionObj={versionObj} />
                        </Grid>
                        <Grid item container xs={12} md={2} lg={1} style={{ ...styles.columnStyles }}>
                            <this.AprovedComponent versionObj={versionObj} />
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    };

    VersionComponent = ({ versionObj }) => {
        try {

            if (!versionObj)
                throw new Error('No versinObj');

            const latestVersion = (versionObj.version && versionObj.version.latestVersion) ? versionObj.version.latestVersion : '###';
            const description = (versionObj && versionObj.description) ? versionObj.description : '';

            //#region 
            const styles = {
                versionStyle: {
                    fontSize: '25px',
                },
                descriptionStyles: {
                    fontSize: '15px',
                },

            }
            //#endregion

            return (
                <Grid item container style={{}} key={'VersionComponent' + versionObj._id} >
                    <Grid item container style={{ ...styles.versionStyle }}>{`Version: ${latestVersion}`}</Grid>
                    <Grid item className='rowEngageStyle' style={{ ...styles.descriptionStyles, }}>{`${description}`}</Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    };

    ReleaseDateComponent = ({ versionObj }) => {

        try {
            if (!versionObj)
                throw new Error('No versinObj');

            //#region  styles
            const styles = {
                releaseDateStyle: {
                    fontSize: '25px',
                },
                dateStyles: {
                    fontSize: '15px'
                }
            }
            //#endregion

            const releaseDate = (versionObj && versionObj.createdAt) ? Moment(versionObj.createdAt).format('MMMM d, yyyy') : undefined;
            const updateDate = (versionObj && versionObj.updateAt) ? Moment(versionObj.updateAt).format('MMMM d, yyyy') : undefined;

            const date = releaseDate ? releaseDate : updateDate;
            return (
                <Grid item container style={{}} key={'VersionComponent' + versionObj._id} >
                    <Grid item container style={{ ...styles.releaseDateStyle }}>{'Release Date'}</Grid>
                    <Grid item container style={{ ...styles.dateStyles }}>{`${date}`}</Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    };

    AprovedComponent = ({ versionObj }) => {
        try {
            if (!versionObj)
                throw new Error('No versinObj');

            //#region Styles
            const styles = {
                aprovedStyles: {
                    fontSize: '25px'
                }
            }
            //#endregion

            const classForCheckBox = versionObj.communityList[0].approved ? 'isChecked' : '';

            return (
                <Grid item container key={'AprovedComponent' + versionObj._id} >
                    <Grid item container justifyContent='center' alignContent='center'>
                        <Grid item style={{ ...styles.aprovedStyles }}>
                            Aproved
                        </Grid>
                    </Grid>
                    <Grid item container justifyContent='center'>
                        <Grid item>
                            <Checkbox
                                id={`Version_row_checkbox_${versionObj._id}`}
                                onClick={(e) => e.stopPropagation()}
                                checked={versionObj.communityList[0].approved}
                                onChange={() => this.toggleAprovedVersionStateHandler(versionObj, !versionObj.communityList[0].approved)}
                                name={'checkBox' + versionObj._id}
                                key={'checkBox' + versionObj._id}
                                className={classForCheckBox}

                            />
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    };

    //#endregion

    //#region HADLERS
    toggleAprovedVersionStateHandler = async (versionObj, newState) => {
        try {
            const newVersionObj = Object.assign({}, versionObj);

            newVersionObj.communityList[0].approved = newState;

            const resp = await this.props.PutCommunityVersion(newVersionObj._id, newVersionObj)
            if (resp.ok) {
                this.props.GetVersionsByCommunity(localStorage.getItem('communityId'), this.state.currentPage);
            }

        } catch (err) { }
    }
    //#endregion

    onExternalIdValueChange(newValue) {

        this.setState({ externalId: newValue });

        if (this.state.initialExternalId === newValue)
            this.props.disableButton()
        else
            this.props.enableButton()
        
    }

    render() {


        /* THIS IS WHERE WE VALIDATE WHEN THE INFORMATION IS SAVED */
        if (this.props.isCommunitySuccess.success && (this.props.isCommunitySuccess.type === ADD_COMMUNITY_SUCCESS || this.props.isCommunitySuccess.type === UPDATE_COMMUNITY_SUCCESS)) {
            this.props.closeDialog(1);
        }

        const breakfastActive = this.state.isActiveBreakFast;
        const lunchActive = this.state.isActiveLunch;
        const dinerActive = this.state.isActiveDinner;


        let breakfastContainer = document.getElementById('breakfastcontainer');
        if (breakfastContainer) {
            const svgElements = breakfastContainer.getElementsByTagName('svg');
            if (svgElements) {
                const breakFastClass = 'activeCalendarElement';


                for (let svg of svgElements) {
                    if (breakfastActive) {
                        svg.classList.add(breakFastClass)
                    } else {
                        svg.classList.remove(breakFastClass)
                    }

                }
            }
        }

        let lunchContainer = document.getElementById('lunchcontainer');
        if (lunchContainer) {
            const svgElements = lunchContainer.getElementsByTagName('svg');
            if (svgElements) {
                const lunchClass = 'activeCalendarElement';
                for (let svg of svgElements) {
                    if (lunchActive) {
                        svg.classList.add(lunchClass);
                    } else {
                        svg.classList.remove(lunchClass);
                    }

                }
            }
        }

        let dinerContainer = document.getElementById('dinercontainer');
        if (dinerContainer) {
            const svgElements = dinerContainer.getElementsByTagName('svg');
            if (svgElements) {
                const dinerClass = 'activeCalendarElement';
                for (let svg of svgElements) {
                    if (dinerActive) {
                        svg.classList.add(dinerClass);
                    } else {
                        svg.classList.remove(dinerClass);
                    }

                }
            }
        }
        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        const { handleSubmit } = this.props;

        const versionData = this.props && this.props.versions && Array.isArray(this.props.versions) ? this.props.versions : []

        if ((this.props.data && this.props.data._id) && this.props.communityExists === false) {
            this.props.handleCommunityExist(true);
        } else if (!(this.props.data && this.props.data._id) && this.props.communityExists === true) {
            this.props.handleCommunityExist(false);
        }

        if (this.props.tabSelected !== this.state.tabValue) {
            this.props.handleTabSelectedChange(this.state.tabValue);
        }

        return (
            <div >
                <form >
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="imgalignrigth-engage appbtn-details-engage">
                                <div id="save_btn" className="appbtn-engage skybluebtn-engage" onClick={handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </div>
                                <div id='sync_community_btn' className='appbtn-engage skybluebtn-engage' onClick={() => {
                                    this.props.SyncCLCommunity(localStorage.getItem('communityId'), { externalId: this.state.externalId ? this.state.externalId : this.props.data.externalId })
                                }}>
                                    Sync Community CL
                                </div>
                                <div id="cancel_btn" className="appbtn-engage redbtn-engage" onClick={this.props.closeDialog}>
                                    Cancel
                                </div>
                                <div id='cancel_resident_btn' className='appbtn-engage skybluebtn-angage' onClick={this.handleCancelUpdateResident}>
                                    Cancel
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    {
                        ///Tabs
                        <React.Fragment>
                            <Grid container >
                                <AppBar position="static" color="default" elevation={0} style={{ backgroundColor: '#2a2a2b' }}>
                                    <Tabs
                                        value={this.state.tabValue}
                                        onChange={this.handleTabChange}
                                        //indicatorColor="transparent"
                                        TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                        variant="fullWidth"
                                        aria-label="full width tabs community"
                                    >
                                        <Tab className='setupInfoSection' label="General" style={(this.state.tabValue === 0) ? this.SelectedTabStyle : this.tabStyles} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                        <Tab className='setupInfoSection' label="Integration" style={(isSuperAdmin === true) ? ((this.state.tabValue === 1) ? this.SelectedTabStyle : this.tabStyles) : this.HiddenTabStyle} {...this.a11yProps(1)} disableRipple={true} disableFocusRipple={true} />
                                        <Tab className='setupInfoSection' label="Community Versions" style={(isSuperAdmin === true && this.state._id) ? ((this.state.tabValue === 2) ? this.SelectedTabStyle : this.tabStyles) : this.HiddenTabStyle} {...this.a11yProps(2)} disableRipple={true} disableFocusRipple={true} />

                                    </Tabs>
                                </AppBar>
                                <SwipeableViews
                                    axis={'x' === 'rtl' ? 'x-reverse' : 'x'}
                                    index={this.state.tabValue}
                                    onChangeIndex={this.handleChangeIndex}
                                    style={{ width: '100%' }}
                                >
                                    {/* TabPanel GENERAL */}
                                    <TabPanel id='setup_general' value={this.state.tabValue} index={0} dir={'x'}>
                                        <Grid container spacing={2} style={{ marginTop: '30px' }}  >

                                            <Grid item xs={4} sm={4} md={4} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12} >
                                                        Profile
                                                    </Grid>
                                                    <Grid item xs={12} id='setup_general_profile' >
                                                        <Grid className='setUpGridColum' container direction='colum'>
                                                            <Grid setupInfoSection item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_profile_name'
                                                                    name="communityName"
                                                                    label="Name"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_profile_nickname'
                                                                    name="communityNickName"
                                                                    label="Nickname"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px', position: 'relative' }}>
                                                                <Field
                                                                    id='setup_general_profile_communityId'
                                                                    name="communityId"
                                                                    label="Comunity ID"
                                                                    maxLength={20}
                                                                    disabled
                                                                    readOnly
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                    endAdornment={
                                                                        this.GetAdornment(
                                                                            {
                                                                                type: 'lock',
                                                                                position: 'end',
                                                                                message: ''
                                                                            }
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px', position: 'relative' }}>
                                                                <Field
                                                                    id='setup_general_profile_externalId'
                                                                    name="externalId"
                                                                    label="External Id"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                    onChange={(e, newItem) => this.onExternalIdValueChange(newItem)}
                                                                    endAdornment={
                                                                        this.GetAdornment(
                                                                            {
                                                                                type: 'sync',
                                                                                position: 'end',
                                                                                color: '#a5a3a4',
                                                                                message: ''
                                                                            }
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_profile_workOrderEmail'
                                                                    name="communityRepairRecipient"
                                                                    label="Work Order Emails"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                    endAdornment={
                                                                        this.GetAdornment(
                                                                            {
                                                                                type: 'info',
                                                                                position: 'end',
                                                                                color: '#a5a3a4',
                                                                                message: 'To enter multiple emails use semicolon as separator.'
                                                                            }
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_profile_logsEmail'
                                                                    name="communityLogsRecipient"
                                                                    label="Logs Emails"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                    endAdornment={
                                                                        this.GetAdornment(
                                                                            {
                                                                                type: 'info',
                                                                                position: 'end',
                                                                                color: '#a5a3a4',
                                                                                message: 'To enter multiple emails use semicolon as separator.'
                                                                            }
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {/* ADDRESS */}
                                            <Grid id='setup_general_address' item xs={4} sm={4} md={4} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        Address
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_address_communityAddresss'
                                                                    name="communityAddress"
                                                                    label="Address"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_address_communityCity'
                                                                    name="communityCity"
                                                                    label="City"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_address_communityState'
                                                                    name="communityState"
                                                                    label="State"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_address_communityZipCode'
                                                                    name="communityZipcode"
                                                                    label="Zip"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {/* IDENTIFIERS */}
                                            <Grid id='setup_general_identifiers' item xs={4} sm={4} md={4} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        Identifiers
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_identifiers_communityMessagingTopic'
                                                                    name="communityMessagingTopic"
                                                                    label="Messaging Topic"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_general_identifiers_communityTags'
                                                                    name="communityTags"
                                                                    label="Tags"
                                                                    value={this.state.textFieldActualText}
                                                                    maxLength={20}
                                                                    chipsOptions={this.state.chipsArray}
                                                                    handlerOnChipDelete={(chipText) => this.handlerOnChipDelete(chipText)}
                                                                    handlerOnClickAddButton={() => { this.setState({ textFieldActualText: '' }); this.handleOnClickAddButton(); }}
                                                                    onChange={(e) => { this.handleOnchangeTextField(e.target.value) }}
                                                                    onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.setState({ textFieldActualText: '' }); this.handleOnClickAddButton(); } }}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextFieldWithChips}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {/* MEALS */}
                                            <Grid id='setup_general_meals' item xs={5} sm={5} md={5} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        Meals
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item container xs={12} style={{ padding: '10px' }}>
                                                                <Grid item container id='breakfastcontainer'>
                                                                    <Grid item xs={12} sm={12} md={12} style={{ paddingTop: '10px', textAlign: 'initial' }}>
                                                                        Breakfast
                                                                    </Grid>
                                                                    <Grid item xs={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                        <Field
                                                                            idToSet='setup_general_meals_breakfast_switch'
                                                                            name="breakfastSwitch"
                                                                            inputClass='breakfastClass'
                                                                            checked={this.state.isActiveBreakFast}
                                                                            onClick={() => { this.ToggleMealSwitch('breakfast') }}
                                                                            component={renderSwitch}
                                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6} sm={6} md={6} >
                                                                        <Field
                                                                            idToSet='setup_general_meals_breakfast_starttime'
                                                                            name="communityBreakfastStartTime"
                                                                            label="Start Time"
                                                                            fieldName={'breakfastStart'}
                                                                            disabled={!this.state.isActiveBreakFast}
                                                                            selectedDate={this.state.breakfastStart}
                                                                            onDateChange={(e, fieldName) => this.setState({ breakfastStart: this.GetValidTime(e, fieldName) })} // 
                                                                            inputClass='setupInfoSection'
                                                                            component={renderTimePicker}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6} sm={6} md={6} >
                                                                        <Field
                                                                            idToSet='setup_general_meals_breakfast_endtime'
                                                                            name="communityBreakfastEndTime"
                                                                            label="End Time"
                                                                            fieldName={'breakfastEnd'}
                                                                            disabled={!this.state.isActiveBreakFast}
                                                                            selectedDate={this.state.breakfastEnd}
                                                                            onDateChange={(e, fieldName) => this.setState({ breakfastEnd: this.GetValidTime(e, fieldName) })}
                                                                            inputClass='setupInfoSection'
                                                                            component={renderTimePicker}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                                <Divider style={this.dividerStyle} />

                                                                <Grid item container id='lunchcontainer'>
                                                                    <Grid item xs={12} sm={12} md={12} style={{ paddingTop: '10px', textAlign: 'initial' }}>
                                                                        Lunch
                                                                    </Grid>
                                                                    <Grid item xs={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                        <Field
                                                                            idToSet='setup_general_meals_lunch_switch'
                                                                            name="LunchSwitch"
                                                                            inputClass='lunchClass'
                                                                            checked={this.state.isActiveLunch}
                                                                            onClick={() => { this.ToggleMealSwitch('lunch') }}
                                                                            component={renderSwitch}
                                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6} sm={6} md={6} >
                                                                        <Field
                                                                            idToSet='setup_general_meals_lunch_starttime'
                                                                            name="communityLunchStartTime"
                                                                            label="Start Time"
                                                                            fieldName={'lunchStart'}
                                                                            disabled={!this.state.isActiveLunch}
                                                                            selectedDate={this.state.lunchStart}
                                                                            onDateChange={(e, fieldName) => this.setState({ lunchStart: this.GetValidTime(e, fieldName) })} // 
                                                                            inputClass='setupInfoSection'
                                                                            component={renderTimePicker}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={6} sm={6} md={6} >
                                                                        <Field
                                                                            idToSet='setup_general_meals_lunch_endtime'
                                                                            name="communityLunchEndTime"
                                                                            label="End Time"
                                                                            fieldName={'lunchEnd'}
                                                                            disabled={!this.state.isActiveLunch}
                                                                            selectedDate={this.state.lunchEnd}
                                                                            onDateChange={(e, fieldName) => this.setState({ lunchEnd: this.GetValidTime(e, fieldName) })}
                                                                            inputClass='setupInfoSection'
                                                                            component={renderTimePicker}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                                <Divider style={this.dividerStyle} />

                                                                <Grid item container id='dinercontainer'>
                                                                    <Grid item xs={12} sm={12} md={12} style={{ paddingTop: '10px', textAlign: 'initial' }}>
                                                                        Dinner
                                                                    </Grid>
                                                                    <Grid item xs={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                        <Field
                                                                            idToSet='setup_general_meals_dinner_switch'
                                                                            name="DinnerSwitch"
                                                                            inputClass='dinerClass'
                                                                            checked={this.state.isActiveDinner}
                                                                            onClick={() => { this.ToggleMealSwitch('diner') }}
                                                                            component={renderSwitch}
                                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6} sm={6} md={6} >
                                                                        <Field
                                                                            idToSet='setup_general_meals_dinner_starttime'
                                                                            name="communityDinnerStartTime"
                                                                            label="Start Time"
                                                                            fieldName={'dinnerStart'}
                                                                            disabled={!this.state.isActiveDinner}
                                                                            selectedDate={this.state.dinnerStart}
                                                                            onDateChange={(e, fieldName) => this.setState({ dinnerStart: this.GetValidTime(e, fieldName) })} // 
                                                                            inputClass='setupInfoSection'
                                                                            component={renderTimePicker}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6} sm={6} md={6} >
                                                                        <Field
                                                                            idToSet='setup_general_meals_dinner_endtime'
                                                                            name="communityDinnerEndTime"
                                                                            label="End Time"
                                                                            fieldName={'dinnerEnd'}
                                                                            disabled={!this.state.isActiveDinner}
                                                                            selectedDate={this.state.dinnerEnd}
                                                                            onDateChange={(e, fieldName) => this.setState({ dinnerEnd: this.GetValidTime(e, fieldName) })}
                                                                            inputClass='setupInfoSection'
                                                                            component={renderTimePicker}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {/* VOICE SETTINGS */}
                                            <Grid id='setup_general_voice_settings' item xs={6} sm={6} md={6} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        Voice Settings
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item container xs={12} style={{ padding: '10px' }}>
                                                                <Grid item container id='breakfastcontainer'>
                                                                    <Grid item xs={2} sm={2} md={2} >
                                                                        <Field
                                                                            idToSet='setup_general_voiceId_switch'
                                                                            name="isVoiceAvailable"
                                                                            checked={this.state.isVoiceAvailable}
                                                                            onClick={this.handleVoiceClick}
                                                                            component={renderSwitchV2}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={10} sm={10} md={10} className="VoiceTitle">
                                                                        Enable voice feature for entire community
                                                                    </Grid>
                                                                    <Grid item xs={2} sm={2} md={2} >
                                                                    </Grid>
                                                                    <Grid item xs={10} sm={10} md={10}>
                                                                        <Grid item xs={12} sm={12} md={12} className="VoiceSubTitle">
                                                                            <h4>Turning this off will disable all eHubs from using voice commands.</h4>
                                                                            <h4>It will also remove TV remote FAV1 and FAV2 button customization.</h4>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    {/******************************************************** TabPanel Integration **************************************************************/}
                                    <TabPanel id='setup_integration' className='setupInfoSection' value={this.state.tabValue} index={1} dir={'x'}>
                                        <Grid container spacing={2} style={{ marginTop: '30px' }} >
                                            <Grid item xs={4} sm={4} md={4} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12} >
                                                        Entertain360
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_entrateinId'
                                                                    name="entertain360.name"
                                                                    label="Entertain ID"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                <Field
                                                                    idToSet='setup_integration_entrateinId_switch'
                                                                    name="entertain360.active"
                                                                    checked={this.state.switchEntertain}
                                                                    onClick={this.handleEntertainClick}
                                                                    component={renderSwitch}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* Ensure 360 */}
                                            <Grid item xs={4} sm={4} md={4} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        Ensure360
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_ensure360'
                                                                    name="ensure360.name"
                                                                    label="Community ID"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                <Field
                                                                    idToSet='setup_integration_ensure360_switch'
                                                                    name="ensure360.active"
                                                                    checked={this.state.switchEnsure}
                                                                    onClick={this.handleEnsureClick}
                                                                    component={renderSwitch}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* WorxHub */}
                                            <Grid item xs={4} sm={4} md={4} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        WorxHub
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_workhub_partnerid'
                                                                    name="worxHub.partnerId"
                                                                    label="Partner ID"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_workhub_partnerkey'
                                                                    name="worxHub.partnerKey"
                                                                    label="Partner Key"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_workhub_thwinstance'
                                                                    name="worxHub.thwInstance"
                                                                    label="THW Instance"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_workhub_thwinstance'
                                                                    name="worxHub.thwSite"
                                                                    label="THW Site"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                <Field
                                                                    idToSet='setup_integration_workhub_switch'
                                                                    name="worxHub.active"
                                                                    checked={this.state.switchWorxHub}
                                                                    onClick={this.handleWorxHubClick}
                                                                    component={renderSwitch}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* Spiro100 */}
                                            <Grid item xs={4} sm={4} md={4} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        Spiro100
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_spiro100_authtoken'
                                                                    name="spiro100.name"
                                                                    label="Auth Token"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                <Field
                                                                    idToSet='setup_integration_spiro100_switch'
                                                                    name="spiro100.active"
                                                                    checked={this.state.switchSpiro}
                                                                    onClick={this.handleSpiroClick}
                                                                    component={renderSwitch}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* CoroHealth */}
                                            <Grid item xs={4} sm={4} md={4}>
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        CoroHealth
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_corohealth_username'
                                                                    name="coroHealth.name"
                                                                    label="Username"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px', position: 'relative' }}>
                                                                <Button
                                                                    id='setup_integration_corohealth_showpassword'
                                                                    onClick={() => this.handleShowPassword()}
                                                                    style={{ position: 'absolute', right: '1rem', bottom: '1rem', zIndex: '1', fontSize: 'medium', color: 'white', }}>
                                                                    {
                                                                        this.state.showPassword ? 'hide' : 'show'
                                                                    }
                                                                </Button>
                                                                <Field
                                                                    id='setup_integration_corohealth_password'
                                                                    name="coroHealth.password"
                                                                    label="Password"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    showPassword={this.state.showPassword}
                                                                    component={renderPasswordField}
                                                                />
                                                            </Grid>
                                                            {/* <Grid item xs={12} sm={12} md={12}  style={{color:'white', textAlign:'right'}}>
                                                            Show Password
                                                            <Field
                                                                name="coroHealth.showPassword.active"
                                                                checked={this.state.showPassword}
                                                                onClick = {this.handleShowPassword}
                                                                component={renderSwitch}
                                                            /> 
                                                        </Grid> */}
                                                            <Grid item xs={12} sm={12} md={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                <Field
                                                                    idToSet='setup_integration_corohealth_switch'
                                                                    name="coroHealth.active"
                                                                    checked={this.state.switchCoroHealth}
                                                                    onClick={this.handleCoroHealthClick}
                                                                    component={renderSwitch}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {/* TELS */}
                                            <Grid item xs={4} sm={4} md={4} >
                                                <Grid container direction='column'>
                                                    <Grid className='setUpTitleEngage' item xs={12}>
                                                        TELS
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <Grid container className='setUpGridColum' direction='colum'>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_tels_businessUnitId'
                                                                    name="tels.businessUnitId"
                                                                    label="Business Unit Id"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='setup_integration_tels_refreshToken'
                                                                    name="tels.refreshToken"
                                                                    label="Refresh Token"
                                                                    maxLength={20}
                                                                    inputClass='setupInfoSection'
                                                                    component={renderTextField}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12} style={{ padding: '10px', textAlign: 'right' }}>
                                                                <Field
                                                                    idToSet='setup_integration_tels_switch'
                                                                    name="tels.active"
                                                                    checked={this.state.switchTELS}
                                                                    onClick={this.handleTELSClick}
                                                                    component={renderSwitch}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    </TabPanel>
                                    <TabPanel id='setup_versions' className='setupInfoSection' value={this.state.tabValue} index={2} dir={'x'}>
                                        <Grid container style={{ marginTop: '30px' }} justifyContent='space-around'  >
                                            <Grid item container>
                                                {
                                                    versionData && versionData.length > 0 ?
                                                        versionData.map((versionObj, index) => (<this.VersionRowComponent key={`listversionObj_${versionObj._id}`} versionObj={versionObj} index={index} />))
                                                        :
                                                        <Grid item container xs={12}>No versions available</Grid>
                                                }
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                </SwipeableViews>
                            </Grid>

                            {
                                this.state.openModalSetVersion ?
                                    <this.VersionListModalComponent versionList={this.props.versions ? this.props.versions : []} />
                                    :
                                    undefined
                            }
                        </React.Fragment>
                    }

                    <Modal
                        open={this.state.showModalVoiceSettings}
                        onClose={() => this.setState({ showModalVoiceSettings: false })}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ borderRadius: '16px' }}
                    >
                        <ModalVoiceSettings
                            OnCancelHandler={this.OnCancelHandler}
                            OnEnableVoice={this.OnEnableVoice}
                            OnDisableVoice={this.OnDisableVoice}
                            enable={this.state.isVoiceAvailable}
                            isCommunity={true}
                        />
                    </Modal>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {

    let versions = (state.ehubVersionReducer && state.ehubVersionReducer.ehubVErsionData) ? state.ehubVersionReducer.ehubVErsionData : [];
    const communitySuccess = state.communityReducer;

    return {
        versions: versions,
        isCommunitySuccess: communitySuccess
    };
}

export default connect(mapStateToProps, { UpdateCommuny, AddCommunity, GetAllVersions, GetVersionsByCommunity, PutCommunityVersion, getALLResidentsByCommunityIDPagination, GetCleanResidents, SyncCLCommunity })(reduxForm({
    form: 'CommunityForm',
    validate,
    enableReinitialize: true,
})(AddEditCommunity));
